module.exports = __webpack_public_path__ + "f1cea09de585517e8ee2029b710dd2e7.png";